module.exports = __webpack_public_path__ + "static/media/moonland.a35cb4cc.mp4";